// API/apiClient.js
import axios from "axios"

const apiClient = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	timeout: 8000,
	withCredentials: true,
	headers: {
		"Content-Type": "application/json",
	},
})
// Response interceptor — normalize errors + handle 401 globally
apiClient.interceptors.response.use(
	(response) => response.data,
	(error) => {
		if (error.code === "ECONNABORTED") {
			return Promise.reject({ status: 408, message: "Request timed out" })
		}
		if (!error.response) {
			return Promise.reject({ status: 0, message: "Network error — check your connection" })
		}
		const { status, data } = error.response
		const message = data?.message ?? fallbackMessage(status)

		if (status === 401) {
			// Session expired — redirect to login without leaving a history entry
			// Import is inline to avoid circular dependency with authContext
			window.dispatchEvent(new CustomEvent("auth:unauthorized"))
		}

		return Promise.reject({ status, message, data })
	},
)

function fallbackMessage(status) {
	const messages = {
		400: "Bad request",
		401: "Unauthorized",
		403: "Access forbidden",
		404: "Resource not found",
		409: "Conflict — resource already exists",
		422: "Validation error",
		429: "Too many requests",
		500: "Server error — try again later",
		503: "Service unavailable",
	}
	return messages[status] ?? "An unexpected error occurred"
}

export default apiClient
